export default function autoRefresh() {
  return {
    enabled: false,
    interval: null,
    storageKey: "",

    init() {
      this.storageKey =
        "autorefresh:" + (this.$el.dataset.key || window.location.pathname);
      const saved = sessionStorage.getItem(this.storageKey);
      if (saved === "true") {
        this.enabled = true;
        this._startPolling();
      }
    },

    toggle() {
      this.enabled = !this.enabled;
      sessionStorage.setItem(this.storageKey, this.enabled);
      if (this.enabled) {
        this._startPolling();
      } else {
        this._stopPolling();
      }
    },

    _startPolling() {
      this._stopPolling();
      this.interval = setInterval(() => {
        this._refreshTable();
      }, 5000);
    },

    _stopPolling() {
      if (this.interval) {
        clearInterval(this.interval);
        this.interval = null;
      }
    },

    _refreshTable() {
      const container = document.getElementById("list-table-container");
      if (!container) return;
      window.htmx.ajax("GET", window.location.href, {
        target: "#list-table-container",
        swap: "innerHTML",
      });
    },

    destroy() {
      this._stopPolling();
    },
  };
}
